"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeFormatter = getTimeFormatter;
const constants_js_1 = require("../../constants.js");
function getTimeFormatter(intlFormatters) {
    return (date, format = 'short') => intlFormatters.formatDate(date, format === 'short' ? constants_js_1.formats.time.short : constants_js_1.formats.time.medium);
}
//# sourceMappingURL=getTimeFormatter.js.map